import { NavigateFn } from "@tanstack/react-router";

const numericSearchKeys = new Set([
  "page",
  "perPage",
  "commonContactsPage",
  "commonContactsPerPage",
  "serviceContactsPage",
  "serviceContactsPerPage",
]);

export function handleCloseParam({
  paramToRemove,
  setSidebar,
  navigate,
}: {
  paramToRemove?: string | string[];
  setSidebar: (node: React.ReactNode | null) => void;
  navigate: NavigateFn;
}) {
  setSidebar(null);

  if (!paramToRemove) return;

  const searchParams = new URLSearchParams(window.location.search);
  if (Array.isArray(paramToRemove)) {
    paramToRemove.forEach((param) => {
      searchParams.delete(param);
    });
  } else {
    searchParams.delete(paramToRemove);
  }

  const searchObj: Record<string, string | number> = {};
  searchParams.forEach((value, key) => {
    if (numericSearchKeys.has(key)) {
      const num = Number(value);
      searchObj[key] = isNaN(num) ? value : num;
    } else {
      searchObj[key] = value;
    }
  });

  navigate({
    to: window.location.pathname,
    search: Object.keys(searchObj).length > 0 ? searchObj : undefined,
    replace: true,
  });
}
